export enum DataGranularity {
    PropertyLevel = 0,
    AggregateLevel = 1
}
